import { createContext } from 'react';
import { LanguageContextType } from '@/types/language-types';

export const LanguageContext = createContext<LanguageContextType | undefined>(undefined); 